import { crypto } from '@binance-chain/javascript-sdk'
import { NETWORK_ENV } from './httpRequest'

const ADDRESS_PREFIX = NETWORK_ENV === 'testnet' ? 'tbnb' : 'bnb'

/**
 * encrypt privatekey with pbkdf2
 * @param {String} privateKeyHex
 * @param {String} password
 * @return {object} encrypted data
 */
export const encryptPrivatekey = (privateKeyHex, password) =>
  crypto.generateKeyStore(privateKeyHex, password)

/**
 * decrypt data to privatekey
 * @param {String} encryptedData
 * @param {String} password
 * @param {String} address
 * @return {String} private key hexstring
 */
export const decryptPrivatekey = (encryptedData, password, address) => {
  const privateKey = crypto.getPrivateKeyFromKeyStore(encryptedData, password)
  const derivedAddress = crypto.getAddressFromPrivateKey(privateKey, ADDRESS_PREFIX)
  if (derivedAddress !== address) {
    throw new Error('wrong password')
  }
  return privateKey
}
